/* tslint:disable */
/* eslint-disable */
/**
 * TOM YARD SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded,
} from '../common'
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from '../base'
// @ts-ignore
import type { GraphRouteRequest } from '../model'
// @ts-ignore
import type { RouteResponse } from '../model'
// @ts-ignore
import type { ShortestRouteResponse } from '../model'
// @ts-ignore
import type { TruckVisitRouteResponse } from '../model'
/**
 * RoutesApi - axios parameter creator
 */
export const RoutesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} [fromNodeId]
     * @param {Array<string>} [toBlockIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    findRoute: async (
      fromNodeId?: string,
      toBlockIds?: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/Routes/FindRoute`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (fromNodeId !== undefined) {
        localVarQueryParameter['fromNodeId'] = fromNodeId
      }

      if (toBlockIds) {
        localVarQueryParameter['toBlockIds'] = toBlockIds
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {GraphRouteRequest} [graphRouteRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    findRouteByGraph: async (
      graphRouteRequest?: GraphRouteRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/Routes/FindRouteByGraph`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        graphRouteRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {GraphRouteRequest} [graphRouteRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    findShortestRouteByGraph: async (
      graphRouteRequest?: GraphRouteRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/Routes/FindShortestRouteByGraph`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        graphRouteRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {number} visitId
     * @param {string} [entryGateId]
     * @param {string} [exitGateId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    truckVisitRoute: async (
      visitId: number,
      entryGateId?: string,
      exitGateId?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'visitId' is not null or undefined
      assertParamExists('truckVisitRoute', 'visitId', visitId)
      const localVarPath = `/yard/api/Routes/TruckVisit/{visitId}`.replace(
        `{${'visitId'}}`,
        encodeURIComponent(String(visitId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (entryGateId !== undefined) {
        localVarQueryParameter['entryGateId'] = entryGateId
      }

      if (exitGateId !== undefined) {
        localVarQueryParameter['exitGateId'] = exitGateId
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * RoutesApi - functional programming interface
 */
export const RoutesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = RoutesApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {string} [fromNodeId]
     * @param {Array<string>} [toBlockIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async findRoute(
      fromNodeId?: string,
      toBlockIds?: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RouteResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.findRoute(
        fromNodeId,
        toBlockIds,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['RoutesApi.findRoute']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {GraphRouteRequest} [graphRouteRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async findRouteByGraph(
      graphRouteRequest?: GraphRouteRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RouteResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.findRouteByGraph(
        graphRouteRequest,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['RoutesApi.findRouteByGraph']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {GraphRouteRequest} [graphRouteRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async findShortestRouteByGraph(
      graphRouteRequest?: GraphRouteRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShortestRouteResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.findShortestRouteByGraph(
        graphRouteRequest,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['RoutesApi.findShortestRouteByGraph']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {number} visitId
     * @param {string} [entryGateId]
     * @param {string} [exitGateId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async truckVisitRoute(
      visitId: number,
      entryGateId?: string,
      exitGateId?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TruckVisitRouteResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.truckVisitRoute(
        visitId,
        entryGateId,
        exitGateId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['RoutesApi.truckVisitRoute']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * RoutesApi - factory interface
 */
export const RoutesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = RoutesApiFp(configuration)
  return {
    /**
     *
     * @param {string} [fromNodeId]
     * @param {Array<string>} [toBlockIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    findRoute(
      fromNodeId?: string,
      toBlockIds?: Array<string>,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<RouteResponse> {
      return localVarFp
        .findRoute(fromNodeId, toBlockIds, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {GraphRouteRequest} [graphRouteRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    findRouteByGraph(
      graphRouteRequest?: GraphRouteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<RouteResponse> {
      return localVarFp
        .findRouteByGraph(graphRouteRequest, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {GraphRouteRequest} [graphRouteRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    findShortestRouteByGraph(
      graphRouteRequest?: GraphRouteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ShortestRouteResponse> {
      return localVarFp
        .findShortestRouteByGraph(graphRouteRequest, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {number} visitId
     * @param {string} [entryGateId]
     * @param {string} [exitGateId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    truckVisitRoute(
      visitId: number,
      entryGateId?: string,
      exitGateId?: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TruckVisitRouteResponse> {
      return localVarFp
        .truckVisitRoute(visitId, entryGateId, exitGateId, options)
        .then(request => request(axios, basePath))
    },
  }
}

/**
 * RoutesApi - object-oriented interface
 */
export class RoutesApi extends BaseAPI {
  /**
   *
   * @param {string} [fromNodeId]
   * @param {Array<string>} [toBlockIds]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public findRoute(
    fromNodeId?: string,
    toBlockIds?: Array<string>,
    options?: RawAxiosRequestConfig,
  ) {
    return RoutesApiFp(this.configuration)
      .findRoute(fromNodeId, toBlockIds, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {GraphRouteRequest} [graphRouteRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public findRouteByGraph(graphRouteRequest?: GraphRouteRequest, options?: RawAxiosRequestConfig) {
    return RoutesApiFp(this.configuration)
      .findRouteByGraph(graphRouteRequest, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {GraphRouteRequest} [graphRouteRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public findShortestRouteByGraph(
    graphRouteRequest?: GraphRouteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return RoutesApiFp(this.configuration)
      .findShortestRouteByGraph(graphRouteRequest, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {number} visitId
   * @param {string} [entryGateId]
   * @param {string} [exitGateId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public truckVisitRoute(
    visitId: number,
    entryGateId?: string,
    exitGateId?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return RoutesApiFp(this.configuration)
      .truckVisitRoute(visitId, entryGateId, exitGateId, options)
      .then(request => request(this.axios, this.basePath))
  }
}
